import AppointmentListPagingResultModelBase from '../_generated/modelBases/appointment-list-paging-result-model-base';

export default class AppointmentListPagingResultModel extends AppointmentListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
